export const getGclid = () => {
    if (typeof window === "undefined") return "";

    // 1.  Cookie written by GTM Conversion Linker (format 1.<ts>.<gclid>)
    const m = document.cookie.match(/_gcl_aw=1\.[0-9]+\.(.+?)(;|$)/);
    if (m) return m[1];

    // 2.  Landing-page URL
    const qs = new URLSearchParams(window.location.search);
    const gclid = qs.get("gclid");
    if (gclid) {
        localStorage.setItem("gclid", gclid);      // persist for later views
        return gclid;
    }

    // 3.  Last-known value
    return localStorage.getItem("gclid") || "";
}
